import { productService } from "../../services/api";
import Product from "../../types/shop/product";

let productList: Product[] = [];

export async function loadProducts() {
  try {
    const response = await productService.getAll();
    const newProductList: Product[] = response.data;
    productList = newProductList.sort((a, b) => a.id - b.id);
  } catch (error) {
    console.error("Failed to load products:", error);
    throw new Error("Не вдалося завантажити продукти");
  }
}

export function getProductList() {
  return productList;
}